import { Component, OnInit, ViewChild,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
// import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fee-head-dialog-box',
  templateUrl: './fee-head-dialog-box.component.html',
  styleUrls: ['./fee-head-dialog-box.component.scss']
})
export class FeeHeadDialogBoxComponent implements OnInit {
  feeHeadForm: FormGroup;
  list;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  purposeList: any;
  filteredpurposeList: any;
  cgList: any;
  isUpdate = false;
  readDelete = false;
  filteredcgList: any;
  submitpayload: any;
  FeeHeadList: any;
  headList: any[];
  APIService: string;
  FeeHeadIddd: any;
  feeCreate = true;
feeUpdate = true;
feeDelete = true;
userPermission:any;
utp: any;
  FeeTemplateSearch: FormGroup;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<FeeHeadDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService
     ) { this.APIService = environment.serviceUrl;}

     dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    this.isUpdate = false;
    this.readDelete = false;
    this.list = true;
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Fee Head' && element.PCreate == false)
      {
          this.feeCreate = false;  
      }
      if(element.PageName == 'Fee Head' && element.PUpdate == false)
      {
          this.feeUpdate = false;  
      }   
      if(element.PageName == 'Fee Head' && element.PDelete == false)
      {
          this.feeDelete = false;  
      } 
    });
  }
    this.feeHeadForm = this.fb.group({
      Head: new FormControl ('',[Validators.required,Validators.pattern('^[a-zA-z0-9-&\\s]*$')]),
      HeadCode: new FormControl ('',[Validators.required,Validators.pattern('^[a-zA-z0-9&\\s]*$')]),
      Uni_Colg: new FormControl ('',[Validators.required]),
      Purpose: new FormControl ('',[Validators.required]),
      Amount: new FormControl (0),
    });
   
    this.fetchPurpose();
    this.fetchCgUni();
    this.getFeeHeadData();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {  
      // alert(this.data.key)
    }
  }

  fetchPurpose() {
    const payload = {};
    payload['CdType'] = 'FEPUR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.purposeList = res.data;
        this.filteredpurposeList = this.purposeList.slice();
      } else {
        
      }
    });
  }

  fetchCgUni() {
    const payload = {};
    payload['CdType'] = 'CgUni';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.cgList = res.data;
        this.filteredcgList = this.cgList.slice();
      } else {
        
      }
    });
  }
  

save(){
  if(this.feeHeadForm.invalid){
    this.feeHeadForm.get('Head').markAsTouched();
    this.feeHeadForm.get('HeadCode').markAsTouched();
    this.feeHeadForm.get('Uni_Colg').markAsTouched();
    this.feeHeadForm.get('Purpose').markAsTouched();
    // this.feeHeadForm.get('Amount').markAsTouched();
  }else{
    this.submitFeehead();
  }
}


  submitFeehead() {
    this.spinner.show();
    this.submitpayload = this.feeHeadForm.value;
    this.submitpayload.Amount = 0
    this.umsService.addFeeHead(this.submitpayload).subscribe(res => { 
      this.spinner.hide();
      if (res.status) {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result)=> {
          // this.dialogRef2.close();
          // this.ngOnInit();
        });
      } else {
        let  data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
   },
   (ERROR:HttpErrorResponse) => {
    this.spinner.hide();
    let  data = {}
    data['message'] = ERROR.error.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
});
  }

getFeeHeadData() {
  this.spinner.show();
    const payload = {};
    this.umsService.getFeeHead(payload).subscribe(res => {
    this.FeeHeadList = res.data;
    this.spinner.hide();
        });
    }
  
update(){
  if(this.feeHeadForm.invalid){
    this.feeHeadForm.get('Head').markAsTouched();
    this.feeHeadForm.get('HeadCode').markAsTouched();
    this.feeHeadForm.get('Uni_Colg').markAsTouched();
    this.feeHeadForm.get('Purpose').markAsTouched();
    // this.feeHeadForm.get('Amount').markAsTouched();
  }else{
    this.updateFeehead();
  }
}

updateFeehead() {
  this.spinner.show();
  this.submitpayload = this.feeHeadForm.value;
 this.submitpayload['FeeHeadId'] = this.FeeHeadIddd;
  this.umsService.updateFeeHead(this.submitpayload).subscribe(res => {
    this.spinner.hide();
    if (res.status){
      let  data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       // this.dialogRef.afterClosed().subscribe(result => {
      //   this.ngOnInit();
      // });
    } else {
      this.spinner.hide();
      let  data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       // this.dialogRef.afterClosed().subscribe(result => {
      //   this.ngOnInit();
      // });
    }
  },(ERROR: HttpErrorResponse) => {
    let  data = {}
    this.spinner.hide();
    data['message'] = ERROR.error.message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
 });
}



editdata(e, k) {
  if (e === 'true') {
    this.list = false;
    this.prepopulation(k);
  } else {
    this.list = true;
  }
}


prepopulation(id) {
  const payload = {};
  payload['FeeHeadId'] = id.FeeHeadId;
  this.FeeHeadIddd =  id.FeeHeadId;
  this.umsService.getFeeHead(payload).subscribe((res) => {
    let data = res.data[0];
    if (res.status) { 
      this.editButton = true;
      this.submitButton = false;
      this.isUpdate = true;
      this.readDelete = false;
      this.deleteButton = false;
      this.feeHeadForm = this.fb.group({
        Head: new FormControl(data.Head, [Validators.required]),
        HeadCode: new FormControl(data.HeadCode, [Validators.required,Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
        Uni_Colg: new FormControl(data.Uni_Colg, [Validators.required,Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
        Purpose: new FormControl(data.Purpose, [Validators.required]),
        Amount: new FormControl(data.Amount),
      });

    } else {
      // this.umsService.openSnackbar(res.message);
    }
  });
}


deletedata(e, k) {
  if (e === 'true') {
    this.list = false;
    this.prepopulationForDelete(k);
  } else {
    this.list = true;
  }
}

prepopulationForDelete(id) {
  const payload = {};
  payload['FeeHeadId'] = id.FeeHeadId;
  this.FeeHeadIddd =  id.FeeHeadId;
  this.umsService.getFeeHead(payload).subscribe((res) => {
    let data = res.data[0];
    if (res.status) { 
      this.editButton = false;
      this.submitButton = false;
      this.deleteButton = true;
      this.isUpdate = false;
      this.readDelete = true;
      this.feeHeadForm = this.fb.group({
        Head: new FormControl(data.Head, [Validators.required]),
        HeadCode: new FormControl(data.HeadCode, [Validators.required,Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
        Uni_Colg: new FormControl(data.Uni_Colg, [Validators.required,Validators.pattern('^[a-zA-z0-9- &\\s]*$')]),
        Purpose: new FormControl(data.Purpose, [Validators.required]),
        Amount: new FormControl(data.Amount),
      });

    } else {
      // this.umsService.openSnackbar(res.message);
    }
  });
}

DeletetheRecord(){
  const  data = {};
  data['message'] = 'Are You Sure You Want To Delete This Record ?';
  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';
  this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes'){
      this.delete(this.feeHeadForm.value);
      this.dialogRef2.close();
    }else{
     // this.ngOnInit();
     this.dialogRef2.close();
    }
  });
 }


 delete(id){
  this.spinner.show();
  const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),  body: {
    Head: id.Head,
    HeadCode: id.HeadCode,
    Uni_Colg: id.Uni_Colg,
    Purpose: id.Purpose,
    Amount: id.Amount,
    FeeHeadId: this.FeeHeadIddd
  },
};
  this.httpClient.delete(this.APIService + '/fees/feehead', options)
  .subscribe((s) => {
    this.spinner.hide();
    // this.spinner.hide();
    let cc = [];
    cc.push(s);
    let  data = {}
    data['message'] = cc[0].message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-check'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  },(ERROR: HttpErrorResponse) => {
    this.spinner.hide();
    let  data = {}
    data['message'] = ERROR.error.message
    data['title'] = 'Alert'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.ngOnInit();
    // this.umsService.openSnackbar(ERROR.error.message);

 });

 }
}

